import React, { memo } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Container from './Container';
import Label from './Label';
import Icon from './Icon';

const StyledLabel = styled(Label)`
  height: 25px;
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const StyledInput = styled.input`
  &:hover:not([readonly]),
  &:focus:not([readonly]) {
    outline: none;
    border-color: ${props => props.theme.border.border700};
  }
  &[readonly] {
    cursor: not-allowed;
    background: ${props => props.theme.background.background200};
    color: ${props => props.theme.text.text300};
    border-color: ${props => props.theme.border.border400};
  }
  &[type='checkbox'] {
    opacity: 0;
    height: 25px;
    width: 25px;
  }
  &[type='checkbox'] + div i {
    content: none;
  }
  &[type='checkbox']:checked + div i {
    opacity: 1;
  }
  &[type='checkbox']:checked + div::before {
    content: '';
    border-color: ${props => props.theme.primary.normal};
    background-color: ${props => props.theme.primary.primary200};
  }
  &[type='checkbox']:focus + div::before {
    outline: none !important;
    border-color: ${props => props.theme.primary.normal};
  }
`;

const StyledContainer = styled(Container)`
  i,
  &:before {
    position: absolute;
    content: '';
    display: inline-block;
  }
  &:before {
    width: 25px;
    height: 25px;
    border-radius: 2px;
    border: solid 1px ${props => props.theme.border.border400};
    background-color: ${props => props.theme.shade.shade200};
    left: -25px;
    top: 1px;
  }
  i {
    color: ${props => props.theme.primary.normal};
    width: 25px;
    height: 25px;
    left: -28px;
    top: 0;
    font-size: 32px;
    opacity: 0;
  }
`;

const CheckBox = memo(
  ({ label, className, name, ...props }) => (
    <StyledLabel htmlFor={`checkbox${name}`} className={className}>
      <StyledInput
        type="checkbox"
        name={name}
        {...props}
        id={`checkbox${name}`}
      />
      <StyledContainer
        flex="1"
        display="flex"
        height="100%"
        alignItems="center"
        position="relative"
        paddingLeft="18px"
        paddingTop="3px"
      >
        {label}
        <Icon className="ls-icon icon-generalticklarge" />
      </StyledContainer>
    </StyledLabel>
  ),
  (prevProps, nextProps) => prevProps.value === nextProps.value
);

CheckBox.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
};
CheckBox.defaultProps = {
  className: undefined,
  label: undefined,
  name: undefined,
};

export default CheckBox;
